import React from 'react';

import { NavItem } from '../components/NavItem';
import { VIEW_TO_PATH } from '../routes';
import { useApp } from '../store/AppContext';
import ManagerNav from './ManagerNav';
import PersonalNav from './sidebarNav/PersonalNav';

export default function SidebarNav() {
  const { navContentRef, navScale } = useApp();
  return (
    <div
      ref={navContentRef}
      className="[transform-origin:top_left]"
      style={{ transform: `scale(${navScale})`, width: `${100 / navScale}%` }}
    >
      <ManagerNav />
      <PersonalNav />
    </div>
  );
}
